module.exports = __webpack_public_path__ + "static/media/money-sent.b2c9a813.svg";